const NonDownloadableAssets = ['Transcript', 'Video', 'Audio', 'Secure Video'];
export default NonDownloadableAssets;
